import { Section } from '@web_opxp/components';
import { AuthSelectors, LanguageSelectors, StatsSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { AppSelectors } from '../../app';
import { SKELETON_DUMMYTEXT, TRAINING_REMINDER } from '../../base/constants';
import * as HistoryService from '../../base/historyService';
import SelectionSection from '../../components/SelectionSection/SelectionSection';
import { CyclesSelectors } from '../../cycles';
import { IState } from '../../store/state';
import { PeerGroupSelectionRoute } from '../AssessmentPage';
import { AssessmentProgress, ProgressPageState } from '../AssessmentProgress';
import { getSavingState, isAssessmentStarted } from '../selectors';
import { AssessmentActions } from '../slice';
import TrainingSchedule from './TrainingSchedule.json';

export interface ITrainingScheduleSubpageProps {
  loading: boolean;
  authorized: boolean;
  started: boolean;
  hasCFQ: boolean;
  isScheduleSelected: boolean;
  onStart: () => void;
  onScheduleSelect: (id: number) => void;
  scheduleSelected: (pushPermission: 0 | 1) => void;
}

export const TrainingScheduleSubpageFC: React.FC<ITrainingScheduleSubpageProps> = ({
  loading,
  authorized,
  started,
  hasCFQ,
  isScheduleSelected,
  onStart,
  onScheduleSelect,
  scheduleSelected,
}) => {
  React.useEffect(() => {
    if (!authorized || started) {
      return;
    }
    onStart();
  });
  const { t } = useTranslation();

  // If schedule is already selected, go to Peer group
  if (isScheduleSelected) {
    scheduleSelected(1);
    HistoryService.redirectInternal(PeerGroupSelectionRoute);
  }

  const title = !loading ? t('postreg:TrainingSchedule.Title') : SKELETON_DUMMYTEXT;
  const scheduleSelectHandler = (id: number) => {
    onScheduleSelect(id);
    HistoryService.redirectInternal(PeerGroupSelectionRoute);
  };

  return (
    <>
      <SelectionSection
        title={title}
        onSelect={scheduleSelectHandler}
        selections={TrainingSchedule.reminderSetup}
        type="large"
        loading={loading}
      />
      <Section>
        <AssessmentProgress page={ProgressPageState.EvaluationDone} cfq={hasCFQ} />
      </Section>
    </>
  );
};

export const mapStateToProps = (state: IState) => {
  const saving = getSavingState(state);
  const appLoading = AppSelectors.isAppLoading(state);
  const langLoading = LanguageSelectors.isLoading(state);
  const isScheduleSelected = !!StatsSelectors.getStatStringValueById(state, TRAINING_REMINDER);
  const authorized = AuthSelectors.isAuthorized(state);
  const started = isAssessmentStarted(state);

  const hasCFQ = CyclesSelectors.doesCurrentSessionHasCFQWorkouts(state);
  return {
    loading: saving || appLoading || langLoading,
    authorized,
    started,
    hasCFQ,
    isScheduleSelected,
  };
};

export const mapDispatchToProps = {
  onScheduleSelect: AssessmentActions.selectTrainingSchedule,
  scheduleSelected: AssessmentActions.trainingScheduleSelected,
  onStart: AssessmentActions.initAssessment,
};

const TrainingScheduleSubpage = connect(mapStateToProps, mapDispatchToProps)(TrainingScheduleSubpageFC);
export default TrainingScheduleSubpage;
